<template>
  <div :id="domUid" :class="composeClass()" role="flash-information">
    <p>{{message}}</p>
  </div>
</template>

<script>
/* global Foundation */
import $ from 'jquery'
export default {
  name: 'flash-reveal',
  props: ['msg'],
  data () {
    return {
    }
  },
  computed: {
    domUid () {
      return 'flash-reveal-' + this._uid
    },
    message () {
      return this.msg ? this.msg.message : ''
    }
  },
  watch: {
    msg: 'onMsgChanged'
  },
  mounted: function () {
  },
  methods: {
    onMsgChanged (msg) {
      if (msg) {
        this.show()
      } else {
        this.hide()
      }
    },
    show () {
      if (!this.revealElement) {
        this.revealElement = new Foundation.Reveal($(this.$el), {})
      }
      $('#' + this.domUid).foundation('open')
    },
    hide () {
      if (this.revealElement) {
        $('#' + this.domUid).foundation('close')
      }
    },
    composeClass () {
      return 'alert tiny reveal ' + (this.msg ? this.msg.class : '')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../sass/foundation-import';
</style>



// WEBPACK FOOTER //
// Reveal.vue?d7fdf7fe